import React, { Component } from 'react';

//css
import styles from '../../static/css/layoutStyleModules/mainLayout.module.scss';

import { CSSTransition } from 'react-transition-group';

//component
import MainViewSelecterTab from './footer/MainViewSelecterTab.js';

import ThanksView from '../pages/ThanksView.js';
import MemberView from '../pages/MemberView.js';
import InfoView from '../pages/InfoView';
import ReloadModalToUpdateComponent from '../components/inputComponent/ReloadModalToUpdateComponent';
import ArticleBase from '../components/articles/ArticleBase';
import InfomationDisplayComponent from '../components/displayStateComponent/InfomationDisplayComponent';


export default class AppMainLayout extends Component {
    constructor(props){
        super(props);
        this.state = {
            viewMode:'thanksView',

            footerMode:'mainViewTab',

            isUpdateModalShown:false,

            isArticleShown:false,
            articleMode:'none',

            isArticleInfoDisplayShown:false,
            articleInfoDisplayImage:'none',
            articleInfoDisplayColor:'transparent',
            articleInfoDisplayMessage:'noMessage',
        }
    }

    componentWillMount = () => {
        window.addEventListener("newContentAvailable", () => {
            this.setState({
                isUpdateModalShown: true
            });
        });

        //ファーストアタックかどうかを調べて、チュートリアルを出す
        if(localStorage.firstAccess === undefined){
            this.setState({viewMode:'none',isArticleShown:true,articleMode:'introduction'});
        }else{
            this.setState({viewMode:'thanksView'});
        }
    }

    changeViewMode = (targetMode) => {
        this.setState({viewMode:targetMode});
    }

    changeFooterMode = (workMode) => {
        if(workMode === 'thanksListMode' || workMode === 'memberListMode'){
            this.setState({footerMode:'mainViewTab'});
        }else{
            this.setState({footerMode:''})
        }
    }

    showInfoDisplay = (image,color,message) => {
        this.setState({
            isArticleInfoDisplayShown:true,
            articleInfoDisplayImage:image,
            articleInfoDisplayColor:color,
            articleInfoDisplayMessage:message,
        })

        setTimeout(() => {
            this.setState({isArticleInfoDisplayShown:false});
        },1000)
    }

    changeArticleMode = (articleMode) => {
        this.setState({articleMode:articleMode});
    }

    endTutorialMode = () => {
        this.setState({viewMode:'thanksView',isArticleShown:false});
    }

    render(){
        const modeComponentList = [
            {component:<ThanksView onWorkModeChange={this.changeFooterMode} key="thanksView"/>, viewMode:'thanksView'},
            {component:<MemberView onWorkModeChange={this.changeFooterMode} key="memberView"/>, viewMode:'memberView'},
            {component:<InfoView onWorkModeChange={this.changeFooterMode} key="infoView"/>, viewMode:'infoView'}
        ]

        const mainLayoutClass = () => {
            if(this.state.footerMode === ''){
                return styles['mainLayoutArea'] + ' ' + styles['noFooter'];
            }else{
                return styles['mainLayoutArea'];
            }
        }
        

        return (
          <div className={mainLayoutClass()}>
            <div className={styles['mainArea']}>
                {modeComponentList.map( value =>  {
                    return(
                        <CSSTransition
                        in={this.state.viewMode === value.viewMode}
                        timeout={200}
                        classNames="simpleFade200"
                        unmountOnExit
                        mountOnEnter
                        key={value.viewMode}
                        >
                          {value.component}
                        </CSSTransition>
                    )
                } )}
            </div>
            <div className={styles['footerTabArea']}>
              <MainViewSelecterTab 
              currentViewMode={this.state.viewMode}
              onTabPanelClick={this.changeViewMode} />
            </div>

            {this.state.isUpdateModalShown && 
                <ReloadModalToUpdateComponent />
            }

            <CSSTransition
            in={this.state.isArticleShown}
            timeout={200}
            classNames="simpleFade200"
            unmountOnExit
            mountOnEnter
            >
              <ArticleBase
              articleMode={this.state.articleMode}
              onInfoDispShow={this.showInfoDisplay}
              onChangeArticle={(articleMode) => this.changeArticleMode(articleMode)}
              onCloseArticle={() => this.setState({isArticleShown:false})}
              onCloseTutorial={this.endTutorialMode}
              />
            </CSSTransition>

            <CSSTransition
            in={this.state.isArticleInfoDisplayShown}
            timeout={200}
            classNames="simpleFade200"
            unmountOnExit
            mountOnEnter
            >
              <InfomationDisplayComponent 
              image={this.state.articleInfoDisplayImage} 
              fillColor={this.state.articleInfoDisplayColor}
              message={this.state.articleInfoDisplayMessage}
              />
            </CSSTransition>

          </div>
        )
    }
}

//header,main,ad,tab